import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Permissions } from "../../modules/users/models";
import permissionsStore from "../../store/permissions";

interface ProtectedRouteProps {
  permissions: Permissions[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permissions }) => {
  const { permissions: userPermissions } = permissionsStore();
  const [, forceUpdate] = useState({});

  useEffect(() => {
    forceUpdate({});
  }, [userPermissions]);

  const hasPermission = permissions.some((permission) =>
    userPermissions.includes(permission)
  );

  if (!hasPermission) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
